export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mixing_mastering.5f92b21.svg";